"use client";

import React from "react";

import { createSVGIcon } from "../util";

/** @optimized using svgo:^3.0.2 */
export const Apple = createSVGIcon(
  <path
    d="M10.127 5.747c-.79 0-2.013-.899-3.3-.867-1.7.022-3.259.986-4.134 2.512-1.765 3.062-.456 7.585 1.265 10.075.845 1.211 1.84 2.575 3.16 2.532 1.267-.054 1.742-.822 3.28-.822 1.525 0 1.958.822 3.3.79 1.364-.022 2.23-1.234 3.063-2.457a10.9 10.9 0 0 0 1.385-2.846c-.033-.01-2.652-1.017-2.684-4.047-.021-2.534 2.067-3.745 2.165-3.8-1.191-1.741-3.02-1.936-3.659-1.98-1.666-.13-3.062.909-3.841.909m2.815-2.555c.702-.844 1.166-2.023 1.037-3.192-1.006.043-2.218.67-2.943 1.515-.65.747-1.212 1.948-1.061 3.095 1.115.087 2.263-.573 2.966-1.418"
    fill="currentColor"
    clipPath="url(#clip0_526_5777)"
  />,
  "Apple",
  (strictLocalize) => ({
    viewBox: "0 0 20 20",
    fill: "none",
    titleAccess: strictLocalize({
      defaultMessage: "Apple logo",
      description: { text: "The label for Apple's company logo icon" },
    }),
  })
);
